import { EventEmitter } from '@angular/core';
import { ModalAction } from './ModalAction';
/**
 * Model representing a survey's collection of modal events.
 * Each emitter represents one modal.
 */
export interface SurveyModalActions {
  steps: EventEmitter<string | ModalAction>[];
  error: EventEmitter<string | ModalAction>;
  processing?: boolean;
}
